<script lang="ts">
	import { page } from '$app/stores';

	const lang = $page.params.locale;
	
	$: isWeddingsPage = $page.url.pathname === `/${lang}/weddings`;
</script>

<section id="fast-btn" class:is-weddings={isWeddingsPage}>
	<div class="d-none d-md-block desktop">
		<div class=""><a href="https://www.ihg.com/holidayinnresorts/hotels/us/en/find-hotels/select-roomrate?fromRedirect=true&qSrt=sBR&qIta=99502222&icdv=99502222&qSlH=DPSBB&qRms=1&qAdlt=1&qChld=0&qCiD=03&qCiMy=02025&qCoD=04&qCoMy=02025&qAAR=6CBARC&qRtP=6CBARC&setPMCookies=true&qSHBrC=HI&qDest=Jl%20Pratama,%20No%2086,%20Tanjung%20Benoa,%20Bali,%20ID&srb_u=1&qChAge=&qRmFltr=" target="_blank" class="btn-1 text-uppercase">Availability</a></div>
		<div class="">
			<a
				data-sveltekit-reload
				href="https://wa.me/628113867152"
				target="_blank"
				class="btn-2"
				data-bs-toggle="tooltip"
				data-bs-placement="left"
				data-bs-title="Chat"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill={isWeddingsPage ? 'black' : 'white'}
					viewBox="0 0 256 256"
					><path
						d="M138,120a10,10,0,1,1-10-10A10,10,0,0,1,138,120ZM84,110a10,10,0,1,0,10,10A10,10,0,0,0,84,110Zm88,0a10,10,0,1,0,10,10A10,10,0,0,0,172,110Zm58-54V184a14,14,0,0,1-14,14H154.41L140.16,223a14,14,0,0,1-24.32,0L101.59,198H40a14,14,0,0,1-14-14V56A14,14,0,0,1,40,42H216A14,14,0,0,1,230,56Zm-12,0a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V184a2,2,0,0,0,2,2h65.07a6,6,0,0,1,5.21,3l16,28a2,2,0,0,0,3.48,0l16-28a6,6,0,0,1,5.21-3H216a2,2,0,0,0,2-2Z"
					></path></svg
				>
			</a>
		</div>
		<div class="">
			<a
				data-sveltekit-reload
				href="tel:623618947888"
				target="_blank"
				class="btn-3"
				data-bs-toggle="tooltip"
				data-bs-placement="left"
				data-bs-title="Call"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill={isWeddingsPage ? 'black' : 'white'}
					viewBox="0 0 256 256"
					><path
						d="M221.59,160.3l-47.24-21.17a14,14,0,0,0-13.28,1.22,4.81,4.81,0,0,0-.56.42l-24.69,21a1.88,1.88,0,0,1-1.68.06c-15.87-7.66-32.31-24-40-39.65a1.91,1.91,0,0,1,0-1.68l21.07-25a6.13,6.13,0,0,0,.42-.58,14,14,0,0,0,1.12-13.27L95.73,34.49a14,14,0,0,0-14.56-8.38A54.24,54.24,0,0,0,34,80c0,78.3,63.7,142,142,142a54.25,54.25,0,0,0,53.89-47.17A14,14,0,0,0,221.59,160.3ZM176,210C104.32,210,46,151.68,46,80A42.23,42.23,0,0,1,82.67,38h.23a2,2,0,0,1,1.84,1.31l21.1,47.11a2,2,0,0,1,0,1.67L84.73,113.15a4.73,4.73,0,0,0-.43.57,14,14,0,0,0-.91,13.73c8.87,18.16,27.17,36.32,45.53,45.19a14,14,0,0,0,13.77-1c.19-.13.38-.27.56-.42l24.68-21a1.92,1.92,0,0,1,1.6-.1l47.25,21.17a2,2,0,0,1,1.21,2A42.24,42.24,0,0,1,176,210Z"
					></path></svg
				>
			</a>
		</div>
		<div class="">
			<a
				data-sveltekit-reload
				href="mailto:reservation.nusadua@ihg.com"
				target="_blank"
				class="btn-4"
				data-bs-toggle="tooltip"
				data-bs-placement="left"
				data-bs-title="Email"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill={isWeddingsPage ? 'black' : 'white'}
					viewBox="0 0 256 256"
					><path
						d="M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50Zm-96,85.86L47.42,62H208.58ZM101.67,128,38,186.36V69.64Zm8.88,8.14L124,148.42a6,6,0,0,0,8.1,0l13.4-12.28L208.58,194H47.43ZM154.33,128,218,69.64V186.36Z"
					></path></svg
				>
			</a>
		</div>
	</div>
</section>

<style>
	#fast-btn .desktop svg {
		width: 1rem;
		height: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 4px 0;
	}
	#fast-btn .desktop .btn-1 {
		background-color: #451C70;
		color: white;
		writing-mode: vertical-rl;
		padding: 20px 12px;
		text-decoration: none;
		transform: rotate(180deg);
		font-family: 'lola-mr';
		font-size: 0.85rem;
		letter-spacing: 1px;
		border-radius: 0px 8px 8px 0px;
		transition: 0.3s all;
		position: fixed;
		top: 225px;
		right: 0%;
		z-index: 99;
	}
	#fast-btn .desktop .btn-1:hover {
		background-color: #1c4b34;
		color: white;
		padding: 20px 10px 20px 20px;
		transition: 0.3s all;
	}
	#fast-btn .desktop .btn-2 {
		background-color: #451C70;
		color: white;
		padding: 8px 15px;
		text-decoration: none;
		font-size: 1rem;
		border-radius: 8px 0px 0px 8px;
		transition: 0.3s all;
		position: fixed;
		top: 365px;
		right: 0%;
		z-index: 99;
	}
	#fast-btn .desktop .btn-2:hover {
		background-color: #1c4b34;
		color: white;
		padding: 8px 20px 8px 15px;
		transition: 0.3s all;
	}
	#fast-btn .desktop .btn-3 {
		background-color: #451C70;
		color: white;
		padding: 8px 15px;
		text-decoration: none;
		font-size: 1rem;
		border-radius: 8px 0px 0px 8px;
		transition: 0.3s all;
		position: fixed;
		top: 410px;
		right: 0%;
		z-index: 99;
	}
	#fast-btn .desktop .btn-3:hover {
		background-color: #1c4b34;
		color: white;
		padding: 8px 20px 8px 15px;
		transition: 0.3s all;
	}
	#fast-btn .desktop .btn-4 {
		background-color: #451C70;
		color: white;
		padding: 8px 15px;
		text-decoration: none;
		font-size: 1rem;
		border-radius: 8px 0px 0px 8px;
		transition: 0.3s all;
		position: fixed;
		top: 455px;
		right: 0%;
		z-index: 99;
	}
	#fast-btn .desktop .btn-4:hover {
		background-color: #1c4b34;
		color: white;
		padding: 8px 20px 8px 15px;
		transition: 0.3s all;
	}

	 /* Styles khusus untuk halaman weddings */
	 #fast-btn.is-weddings  .desktop .btn-1 {
		background-color: #9bc5b7;
		color: black;
		writing-mode: vertical-rl;
		padding: 20px 12px;
		text-decoration: none;
		transform: rotate(180deg);
		font-family: 'lola-mr';
		font-size: 0.85rem;
		letter-spacing: 1px;
		border-radius: 0px 8px 8px 0px;
		transition: 0.3s all;
		position: fixed;
		top: 225px;
		right: 0%;
		z-index: 99;
	}
	#fast-btn.is-weddings  .desktop .btn-1:hover {
		background-color: #1c4b34;
		color: black;
		padding: 20px 10px 20px 20px;
		transition: 0.3s all;
	}
	#fast-btn.is-weddings  .desktop .btn-2 {
		background-color: #9bc5b7;
		color: black;
		padding: 8px 15px;
		text-decoration: none;
		font-size: 1rem;
		border-radius: 8px 0px 0px 8px;
		transition: 0.3s all;
		position: fixed;
		top: 365px;
		right: 0%;
		z-index: 99;
	}
	#fast-btn.is-weddings  .desktop .btn-2:hover {
		background-color: #1c4b34;
		color: white;
		padding: 8px 20px 8px 15px;
		transition: 0.3s all;
	}
	#fast-btn.is-weddings  .desktop .btn-3 {
		background-color: #9bc5b7;
		color: black;
		padding: 8px 15px;
		text-decoration: none;
		font-size: 1rem;
		border-radius: 8px 0px 0px 8px;
		transition: 0.3s all;
		position: fixed;
		top: 410px;
		right: 0%;
		z-index: 99;
	}
	#fast-btn.is-weddings  .desktop .btn-3:hover {
		background-color: #1c4b34;
		color: white;
		padding: 8px 20px 8px 15px;
		transition: 0.3s all;
	}
	#fast-btn.is-weddings  .desktop .btn-4 {
		background-color: #9bc5b7;
		color: black;
		padding: 8px 15px;
		text-decoration: none;
		font-size: 1rem;
		border-radius: 8px 0px 0px 8px;
		transition: 0.3s all;
		position: fixed;
		top: 455px;
		right: 0%;
		z-index: 99;
	}
	#fast-btn.is-weddings  .desktop .btn-4:hover {
		background-color: #1c4b34;
		color: white;
		padding: 8px 20px 8px 15px;
		transition: 0.3s all;
	}
</style>
